import { render, staticRenderFns } from "./addCardModal.vue?vue&type=template&id=054fe9b4&scoped=true&"
import script from "./addCardModal.vue?vue&type=script&lang=js&"
export * from "./addCardModal.vue?vue&type=script&lang=js&"
import style0 from "./addCardModal.vue?vue&type=style&index=0&id=054fe9b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054fe9b4",
  null
  
)

export default component.exports